import { BlockRenderer } from "@/components/ChatResponseElements";

export default function Phase1ArtifactBlocks({ blocks, citations, streaming, animateEnter }) {
  if (!blocks.length) return null;
  return (
    <BlockRenderer
      blocks={blocks}
      citations={citations}
      streaming={streaming}
      animateEnter={animateEnter}
    />
  );
}
